import { observer } from 'mobx-react';
import { FC } from 'react';
import kioskEditStore from '../../store/kioskEditStore';
import Text from '~/view/components/Text/Text';

const KioskId: FC = observer((): JSX.Element => {
  return (
    <div className="kiosk__field">
      <Text type="order-field" text="kiosk_id" className="kiosk__field-title m-0" />
      <p className="text-size-16 family-semibold flex-1">{kioskEditStore.editableKiosk.id}</p>
    </div>
  );
});

export default KioskId;
